import { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import { Session } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { DisplayProductsResult } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import {
    BillToModel,
    CartLineModel,
    CartModel,
    ProductModel,
    ProductPriceDto,
    WishListModel,
} from "@insite/client-framework/Types/ApiModels";   


let lastTrackedUrl = "";
// get global for google tag manager
function getDataLayer() {
    return (window as any).dataLayer;
}
interface LineItem {
    item_id: string;
    item_name: string;
    affiliation?: string;
    coupon?: string;
    discount?: number;
    index: number;
    item_brand: string;
    item_category: string; // add in properties from backend
    item_category2?: string; // add in properties from backend
    item_category3?: string; // add in properties from backend
    item_category4?: string; // add in properties from backend
    item_category5?: string; // add in properties from backend
    item_list_id?: string; // add in properties from backend
    item_list_name?: string; // add in properties from backend
    item_variant: string;
    location_id: string; // add in properties from backend
    price?: number;
    quantity?: number;
}
interface TransactionData {
    event: string;
    ecommerce: {
        currency?: string;
        value?: number;
        transaction_id: string;
        coupon?: string;
        items: LineItem[];
    };
}
export interface FulfilmentMethodTrackingData {
    event: string;
    form_action: string;
    form_category: string;
    form_name: string;
    form_type: string;
    form_selections: {
        form_field_name: string;
        form_field_value: string;
    }[];
}
export interface FormErrorsData {
    event: string; // "form_error";
    form_category: string; // "<<form category designation>>";
    form_action: string; // "form error";
    form_name: string;
    event_label: string; // "failure";
    form_errors: {
        form_field_name: string;
        error_message: string;
    }[];
}
interface AddToListData {
    event: string;
    ecommerce: {
        currency?: string;
        value?: number;
        items: {
            item_id: string;
            item_name: string;
            index: number;
            item_brand: string;
            item_category: string; // add in properties from backend
            item_category2?: string; // add in properties from backend
            item_category3?: string; // add in properties from backend
            item_category4?: string; // add in properties from backend
            item_category5?: string; // add in properties from backend
            item_list_id?: string; // add in properties from backend
            item_list_name?: string; // add in properties from backend           
            location_id: string; // add in properties from backend
            price?: number;
            quantity?: number;
        }[];
    };
}

interface PromotionData {
    event: string;
    ecommerce: {
        creative_name: string;
        creative_slot: string;
        promotion_id: string;
        promotion_name: string;
        items: {
            item_id: string;
            item_name: string;
            index: number;
            item_brand: string;
            item_category: string; // add in properties from backend
            item_category2?: string; // add in properties from backend
            item_category3?: string; // add in properties from backend
            item_category4?: string; // add in properties from backend
            item_category5?: string; // add in properties from backend
            item_list_id?: string; // add in properties from backend
            item_list_name?: string; // add in properties from backend
           
            location_id: string; // add in properties from backend
            price?: number;
            quantity?: number;
        }[];
    };
}
interface ProductListingData {
    event: string;
    ecommerce: {
        item_list_id: string;
       
        items: {
            item_id: string;
            item_name: string;
            affiliation?: string;
            coupon?: string;
            discount?: number;
            index: number;
            item_brand: string;
            item_category: string; // add in properties from backend
            item_category2?: string; // add in properties from backend
            item_category3?: string; // add in properties from backend
            item_category4?: string; // add in properties from backend
            item_category5?: string; // add in properties from backend
            item_list_id?: string; // add in properties from backend
            item_list_name?: string; // add in properties from backend
            item_variant?: string;
            location_id: string; // add in properties from backend
            price?: number;
            quantity?: number;
        }[];
    };
}
interface ProductDetailsData {
    event: string;
    ecommerce: {
        currency?: string;
        value?: number;
        items: {
            item_id: string;
            item_name: string;
            
            item_brand?: string;
            item_category: string; // add in properties from backend
            item_category2?: string; // add in properties from backend
            item_category3?: string; // add in properties from backend
            item_category4?: string; // add in properties from backend
            item_category5?: string; // add in properties from backend
            
            location_id: string; // add in properties from backend
            price?: number;
            quantity?: number;
        }[];
    };
}

export interface CTAEventData {
    event: string;
    nav_menu_category?: string;
    nav_menu_click_text?: string;
    nav_menu_click_title?: string;
    nav_menu_click_destination?: string;
}
export interface CTAFooterEventData {
    event: string;
    footer_click_category?: string;
    footer_click_text?: string;
    footer_click_title?: string;
    footer_click_destination?: string;
}
export interface MainCTAEventData {
    event: string;
    cta_click_ui_location?: string;
    cta_click_text?: string;
    cta_click_title?: string;
    cta_click_destination?: string;
}

interface QuickOrderProductData{
        event: string;
        ecommerce: {
            currency?: string;
            reason?:string;
            items: {
                item_id: string;
                item_name: string;
                affiliation:string;
                coupon:string;
                discount:string;
                index: number;
                item_brand: string|undefined;
                item_category: string; // add in properties from backend
                item_category2?: string; // add in properties from backend
                item_category3?: string; // add in properties from backend
                item_category4?: string; // add in properties from backend
                item_category5?: string; // add in properties from backend
                item_list_name?: string; // add in properties from backend
                item_variant: string; // add in properties from backend               
                location_id: string; // add in properties from backend
                price?: number;
                quantity?: number;
            }[];
        };
  
}
interface QuickOrderSearchData{
    event: string;
    search_term:string;
    search_type:string;
}

interface BulkUploadData{
    event: string;
    currency:string;
    outbound:boolean;
}
export function trackCompletedOrder(cart: CartModel, billTo?: BillToModel, session?: Session) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const data: TransactionData = {
        event: "purchase",
        ecommerce: {
            currency: session?.currency?.currencyCode,
            value: cart.orderGrandTotal,
            transaction_id: cart.orderNumber,
            coupon: cart?.promotionCode ?? "",
            items: [],
        },
    };
    try {
        const nearestWarehouse = `${session?.pickUpWarehouse?.name} ${session?.pickUpWarehouse?.postalCode} ${session?.pickUpWarehouse?.phone} ${session?.pickUpWarehouse?.description}`;

        const location = getCurrentLocation();
       
        let lineDiscount: number;
        cart.cartLines?.forEach((cartLine, index) => {
            lineDiscount = parseInt(cartLine.properties?.discount, 10);
            let catArray;
            if (cartLine.properties?.lineCategories) {
                catArray = cartLine.properties?.lineCategories.split("|");
                catArray = [...new Set(catArray)];
            }
            let cat1 = "";
            let cat2 = "";
            let cat3 = "";
            let cat4 = "";
            let cat5 = "";

            if (catArray && catArray.length > 0) {
                const [firstCat, secondCat, thirdCat, fourthCat, fifthCat] = catArray;
                cat1 = firstCat || "";
                cat2 = secondCat || "";
                cat3 = thirdCat || "";
                cat4 = fourthCat || "";
                cat5 = fifthCat || "";
            }

            const cartLinePrice = cartLine.pricing
                ? getUnitNetPrice(cartLine.pricing, cartLine.qtyOrdered || 1).priceDisplay.substring(1)
                : (cartLine.pricing as ProductPriceDto | null)?.unitNetPriceDisplay.substring(1);
            data.ecommerce.items.push({
                item_id: cartLine.erpNumber,
                item_name: cartLine.shortDescription,
                affiliation: cart?.billTo?.companyName,
                coupon: cart.promotionCode ?? "",
                discount: cartLine.isPromotionItem ? lineDiscount : 0.0,
                index,
                item_brand: cartLine?.brand?.name ?? "",
                item_category: cat1,
                item_category2: cat2,
                item_category3: cat3,
                item_category4: cat4,
                item_category5: cat5,
                item_variant: "",
                location_id: location?.name ?? nearestWarehouse,
                price: Number(cartLinePrice),
                quantity: cartLine.qtyOrdered ?? undefined,
            });
        });

        setTimeout(() => {
            dataLayer.push({ ecommerce: null });
            dataLayer.push(data);
        }, 1000);
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}
export function trackGlobalVariableDetails(state: ApplicationState) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const url = window.location.pathname + window.location.search;
    if (url === lastTrackedUrl) {
        return;
    }

    lastTrackedUrl = url;

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    // / need to discuss with client for remaining properties
    try {
        const location = getCurrentLocation();
        const currentPage = getCurrentPage(state);

        const urlSplit = window.location.pathname.split("/");
        let category = "";
        let subCategory = "";
        if (urlSplit.length > 0) {
            category = urlSplit[1];
            subCategory = urlSplit[2];
        }

        let links = state.components?.breadcrumbs?.links;

        links = links?.slice(1);
        const pageLinks = links?.map((x: any) => x.children);
        const nearestWarehouse = `${state.context.session.pickUpWarehouse?.name} ${state.context.session.pickUpWarehouse?.postalCode} ${state.context.session.pickUpWarehouse?.phone} ${state.context.session.pickUpWarehouse?.description}`;
        const session = state.context.session;

        const globalVariables = {
            event: "virtualPageViewFinish",
            user_id: session?.userName ?? "",
            user_role: session?.userRoles ?? "",
            gtm_branch_id: location?.name ?? nearestWarehouse,
            gtm_category: category ?? currentPage.name,
            gtm_environment: IS_PRODUCTION ? "production" : "development",
            gtm_page_name: currentPage.name,
            gtm_page_url: url ?? "",
            gtm_page_type: currentPage.type ?? "",
            gtm_site_hierarchy: pageLinks ?? [],
            gtm_subcategory: subCategory ?? "",
        };

        dataLayer.push(globalVariables);
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}

export function trackLoginUserDetails(state: ApplicationState) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const userName = state.context.session.userName;
        const loginEvent = {
            event: "login",
            user_id: userName,
        };

        if (userName) {
            dataLayer.push(loginEvent);
        }
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}

export function trackLoggedOutUserDetails(state: ApplicationState) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const userName = state.context.session.userName;
        const logoutEvent = {
            event: "logout",
            user_id: userName,
        };
        if (userName) {
            dataLayer.push(logoutEvent);
        }
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}
export function getCurrentLocation() {
    let storeLocation: LocationModel;

    if (sessionStorage.getItem("selectedLocationData")) {
        const a = sessionStorage.getItem("selectedLocationData");
        let b: any;
        if (a != null) {
            b = JSON.parse(a);
            storeLocation = b.location;
            return storeLocation;
        }
    }
}

export async function trackAddToCart(cartLine: CartLineModel, qtyOrdered: number, state: ApplicationState) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const nearestWarehouse = `${state.context.session.pickUpWarehouse?.name} ${state.context.session.pickUpWarehouse?.postalCode} ${state.context.session.pickUpWarehouse?.phone} ${state.context.session.pickUpWarehouse?.description}`;

        const session = state.context.session;
        const location = getCurrentLocation();
        let catArray;
        if (cartLine.properties?.lineCategories) {
            catArray = cartLine.properties?.lineCategories.split("|");
            catArray = [...new Set(catArray)];
        }
        let cat1 = "";
        let cat2 = "";
        let cat3 = "";
        let cat4 = "";
        let cat5 = "";

        if (catArray && catArray.length > 0) {
            const [firstCat, secondCat, thirdCat, fourthCat, fifthCat] = catArray;
            cat1 = firstCat || "";
            cat2 = secondCat || "";
            cat3 = thirdCat || "";
            cat4 = fourthCat || "";
            cat5 = fifthCat || "";
        }
        await waitFor(() => !!cartLine?.pricing?.unitNetPriceDisplay);
        const cartLinePrice = cartLine.pricing
            ? getUnitNetPrice(cartLine.pricing, qtyOrdered || 1).priceDisplay.substring(1)
            : (cartLine.pricing as ProductPriceDto | null)?.unitNetPriceDisplay.substring(1);

        const item = {
            item_id: cartLine.erpNumber, // "SKU_12345",
            item_name: cartLine.shortDescription, // "Stan and Friends Tee",
            // affiliation: "Google Merchandise Store", // Need to discuss with client
            index: cartLine.idx,
            item_brand: cartLine.brand?.name, // "Google",
            item_category: cat1,
            item_category2: cat2,
            item_category3: cat3,
            item_category4: cat4,
            item_category5: cat5,
            // item_variant: "green",
            location_id: location?.name ?? nearestWarehouse,
            price: Number(cartLinePrice),
            quantity: qtyOrdered,
        };
        const totalPrice = Number(cartLinePrice) * qtyOrdered;
        const addToCartEvent = {
            event: "add_to_cart",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                value: Number(totalPrice),
                items: [item],
            },
        };
        setTimeout(() => {
            dataLayer.push({ ecommerce: null });
            dataLayer.push(addToCartEvent);
        }, 1000);
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}
export function trackProductListing(result: DisplayProductsResult, state: ApplicationState) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const nearestWarehouse = `${state.context.session.pickUpWarehouse?.name} ${state.context.session.pickUpWarehouse?.postalCode} ${state.context.session.pickUpWarehouse?.phone} ${state.context.session.pickUpWarehouse?.description}`;

        const location = getCurrentLocation();

        const data: ProductListingData = {
            event: "view_item_list",
            ecommerce: {
                item_list_id: "Product Listing",
                items: [],
            },
        };

        result.products?.forEach((product, index) => {
            const productInfo = state.pages.productList.productInfosByProductId[product.id];

            const productPrice = productInfo?.pricing
                ? getUnitNetPrice(productInfo?.pricing, 1).priceDisplay.substring(1)
                : product.unitListPriceDisplay.substring(1);
            let catArray;
            if (product.properties?.lineCategories) {
                catArray = product.properties?.lineCategories.split("|");
                catArray = [...new Set(catArray)];
            }
            let cat1 = "";
            let cat2 = "";
            let cat3 = "";
            let cat4 = "";
            let cat5 = "";

            if (catArray && catArray.length > 0) {
                const [firstCat, secondCat, thirdCat, fourthCat, fifthCat] = catArray;
                cat1 = firstCat || "";
                cat2 = secondCat || "";
                cat3 = thirdCat || "";
                cat4 = fourthCat || "";
                cat5 = fifthCat || "";
            }
            data.ecommerce.items.push({
                item_id: product.productNumber,
                item_name: product.productTitle,
                index,
                item_brand: product?.brand?.name ?? "",
                item_category: cat1,
                item_category2: cat2,
                item_category3: cat3,
                item_category4: cat4,
                item_category5: cat5,
                item_variant: "",
                location_id: location?.name ?? nearestWarehouse,
                price: Number(productPrice),
            });
        });

        setTimeout(() => {
            dataLayer.push({ ecommerce: null });
            dataLayer.push(data);
        }, 1000);
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}

export function trackProductDetails(product: ProductModel, state: ApplicationState) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const location = getCurrentLocation();
        const productInfoById = state?.pages?.productDetails?.productInfosById;
        const productInfo = productInfoById ? productInfoById[product.id] : null;
        const nearestWarehouse = `${state.context.session.pickUpWarehouse?.name} ${state.context.session.pickUpWarehouse?.postalCode} ${state.context.session.pickUpWarehouse?.phone} ${state.context.session.pickUpWarehouse?.description}`;
        const productPrice = productInfo?.pricing
            ? getUnitNetPrice(productInfo?.pricing, 1).priceDisplay.substring(1)
            : product.unitListPriceDisplay.substring(1);
        let catArray;
        if (product.properties?.lineCategories) {
            catArray = product.properties?.lineCategories.split("|");
            catArray = [...new Set(catArray)];
        }
        let cat1 = "";
        let cat2 = "";
        let cat3 = "";
        let cat4 = "";
        let cat5 = "";

        if (catArray && catArray.length > 0) {
            const [firstCat, secondCat, thirdCat, fourthCat, fifthCat] = catArray;
            cat1 = firstCat || "";
            cat2 = secondCat || "";
            cat3 = thirdCat || "";
            cat4 = fourthCat || "";
            cat5 = fifthCat || "";
        }
        const productDetails: ProductDetailsData = {
            event: "view_item",
            ecommerce: {
                currency: state.context.session?.currency?.currencyCode,
                value: Number(productPrice),
                items: [
                    {
                        item_id: product.productNumber, // "SKU_12345",
                        item_name: product.productTitle, // "Stan and Friends Tee",
                        item_brand: product.brand?.name, // "Google",
                        item_category: cat1,
                        item_category2: cat2,
                        item_category3: cat3,
                        item_category4: cat4,
                        item_category5: cat5,
                        location_id: location?.name ?? nearestWarehouse,
                        price: Number(productPrice),
                        quantity: 1,
                    },
                ],
            },
        };
        setTimeout(() => {
            dataLayer.push({ ecommerce: null });
            dataLayer.push(productDetails);
        }, 1000);
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}

export function trackAddToList(
    wishListModel: WishListModel | undefined,
    productInfos: ProductInfo[],
    state: ApplicationState,
    
) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const nearestWarehouse = `${state.context.session.pickUpWarehouse?.name} ${state.context.session.pickUpWarehouse?.postalCode} ${state.context.session.pickUpWarehouse?.phone} ${state.context.session.pickUpWarehouse?.description}`;

        const location = getCurrentLocation();
       
        
      
            const addToListDetails: AddToListData = {
                event: "add_to_wishlist",
                ecommerce: {
                    currency: state.context.session?.currency?.currencyCode,
                    items: [],
                },
            };
            const value = 0;
    
            // Define an array of objects with key-value pairs
    
            productInfos?.forEach(async (productInfo, index) => {
                const cartLine = wishListModel?.wishListLineCollection?.find(x => x.productId === productInfo.productId);
    
                if (cartLine) {
                    await waitFor(() => !!cartLine?.pricing?.unitNetPriceDisplay);
                    // const unitListPrice = cartLine?.pricing?.unitRegularPrice;
                    const cartLinePrice = (cartLine.pricing as ProductPriceDto | null)?.unitNetPriceDisplay.substring(1);
                    // console.log("cartLine?.pricing =>", cartLine?.pricing);
                    let catArray;
                    if (cartLine.properties?.lineCategories) {
                        catArray = cartLine.properties?.lineCategories.split("|");
                        catArray = [...new Set(catArray)];
                    }
                    let cat1 = "";
                    let cat2 = "";
                    let cat3 = "";
                    let cat4 = "";
                    let cat5 = "";
    
                    if (catArray && catArray.length > 0) {
                        const [firstCat, secondCat, thirdCat, fourthCat, fifthCat] = catArray;
                        cat1 = firstCat || "";
                        cat2 = secondCat || "";
                        cat3 = thirdCat || "";
                        cat4 = fourthCat || "";
                        cat5 = fifthCat || "";
                    }
    
                    const value = Number(cartLinePrice) * productInfo?.qtyOrdered;
                    addToListDetails.ecommerce.value = value;
                    addToListDetails.ecommerce.items.push({
                        item_id: cartLine.erpNumber,
                        item_name: cartLine.shortDescription,
                        index,
                        item_brand: cartLine?.brand?.name ?? "",
                        item_category: cat1,
                        item_category2: cat2,
                        item_category3: cat3,
                        item_category4: cat4,
                        item_category5: cat5,
                        item_list_id: wishListModel?.id ?? "",
                        item_list_name: wishListModel?.name ?? "",
                        // item_variant: "",
                        location_id: location?.name ?? nearestWarehouse,
                        price: Number(cartLinePrice),
                        quantity: productInfo.qtyOrdered || 1,
                    });
                }
            });
            // Added Set time out to log an event 1 sec late for complete the pricing api call
            setTimeout(() => {
                dataLayer.push({ ecommerce: null });
                dataLayer.push(addToListDetails);
            }, 1000);
       
       
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}

export async function trackRemoveCartLine(cartLine: CartLineModel, state: ApplicationState) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const nearestWarehouse = `${state.context.session.pickUpWarehouse?.name} ${state.context.session.pickUpWarehouse?.postalCode} ${state.context.session.pickUpWarehouse?.phone} ${state.context.session.pickUpWarehouse?.description}`;

        const session = state.context.session;
        const location = getCurrentLocation();
        let catArray;

        if (cartLine.properties?.lineCategories) {
            catArray = cartLine.properties?.lineCategories.split("|");
            catArray = [...new Set(catArray)];
        }
        let cat1 = "";
        let cat2 = "";
        let cat3 = "";
        let cat4 = "";
        let cat5 = "";

        if (catArray && catArray.length > 0) {
            const [firstCat, secondCat, thirdCat, fourthCat, fifthCat] = catArray;
            cat1 = firstCat || "";
            cat2 = secondCat || "";
            cat3 = thirdCat || "";
            cat4 = fourthCat || "";
            cat5 = fifthCat || "";
        }
        await waitFor(() => !!cartLine?.pricing?.unitNetPriceDisplay);
        const cartLinePrice = (cartLine.pricing as ProductPriceDto | null)?.unitNetPriceDisplay.substring(1);
        const extendedUnitNetPrice = (
            cartLine.pricing as ProductPriceDto | null
        )?.extendedUnitNetPriceDisplay.substring(1);
        const item = {
            item_id: cartLine.erpNumber,
            item_name: cartLine.shortDescription,
            index: cartLine.idx,
            item_brand: cartLine.brand?.name,
            item_category: cat1,
            item_category2: cat2,
            item_category3: cat3,
            item_category4: cat4,
            item_category5: cat5,
            location_id: location?.name ?? nearestWarehouse,
            price: Number(cartLinePrice),
            quantity: cartLine.qtyOrdered,
        };

        const removeFromCartEvent = {
            event: "remove_from_cart",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                value: Number(extendedUnitNetPrice),
                items: [item],
            },
        };
        setTimeout(() => {
            dataLayer.push({ ecommerce: null });
            dataLayer.push(removeFromCartEvent);
        }, 1000);
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}
export function trackRequestLoginForm(formSelections: any[]) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const requestForLoginEvent = {
        event: "form_submit",
        form_action: "submit",
        form_category: "registration",
        form_name: "request online login",
        form_type: "settings",
        form_selections: formSelections,
    };

    dataLayer.push(requestForLoginEvent);
}
export function trackPickupWarehouseChange(fulfilmentOptionChange: FulfilmentMethodTrackingData) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    dataLayer.push(fulfilmentOptionChange);
}
export function trackFormError(formErrorData: any) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    dataLayer.push(formErrorData);
}




export function trackCTAHeaderClickEvent(headerEvent: CTAEventData) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    dataLayer.push(headerEvent);
}
export function trackCTAFooterClickEvent(footerEvent: CTAFooterEventData) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    dataLayer.push(footerEvent);
}


export  function trackAddProductToQuickOrderGrid(
     product:ProductModel,
) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const quickOrderToGridDetails: QuickOrderSearchData = {
            event: "search",
            search_term:product.productNumber,
            search_type:"quick order"
            
        };
            
            dataLayer.push(quickOrderToGridDetails);
        
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}
export  function trackAddAllToCart(
    cartLines: CartLineModel[]|null,
    state: ApplicationState,
) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    
            if (cartLines && cartLines.length > 0) {
               

    try {
        const nearestWarehouse = `${state.context.session.pickUpWarehouse?.name} ${state.context.session.pickUpWarehouse?.postalCode} ${state.context.session.pickUpWarehouse?.phone} ${state.context.session.pickUpWarehouse?.description}`;

        const location = getCurrentLocation();
        const quickOrderToCartDetails: QuickOrderProductData = {
            event: "add_to_cart",
            ecommerce: {
                currency: state.context.session?.currency?.currencyCode,
                items: [],
            },
        };

        cartLines.forEach((line,index)=>{
    let catArray;

    if (line.properties?.lineCategories) {
        catArray = line.properties?.lineCategories.split("|");
        catArray = [...new Set(catArray)];
    }
    let cat1 = "";
    let cat2 = "";
    let cat3 = "";
    let cat4 = "";
    let cat5 = "";

    if (catArray && catArray.length > 0) {
        const [firstCat, secondCat, thirdCat, fourthCat, fifthCat] = catArray;
        cat1 = firstCat || "";
        cat2 = secondCat || "";
        cat3 = thirdCat || "";
        cat4 = fourthCat || "";
        cat5 = fifthCat || "";
    }
    quickOrderToCartDetails.ecommerce.reason = "";
    quickOrderToCartDetails.ecommerce.items.push(
        {
            item_id: line.erpNumber,
            item_name: line.shortDescription,
            affiliation: "",
            coupon: "",
            discount: "",
            index:index+1,
            item_brand: line.brand?.name || "",
            item_category: cat1,
            item_category2: cat2,
            item_category3: cat3,
            item_category4: cat4,
            item_category5: cat5,
            location_id: location?.name || nearestWarehouse,
            item_list_name:"",
            item_variant: "",
            price:line.pricing?.unitNetPrice,
            quantity:line.qtyOrdered || 1
        }
    );
});
    dataLayer.push(quickOrderToCartDetails);
}
catch (e) {
    console.log("Tracking Exception =>", e);
}

   
}
}

export function trackBulkOrderSuccess(
    session:Session,
){
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const bulkUploadDetails: BulkUploadData = {
            event: "upload_order",
            currency:session?.currency?.currencyCode || "",
            outbound:false,
            
        };
            
            dataLayer.push(bulkUploadDetails);
        
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}




const window = global.window;

if (window?.document !== undefined) {
    const reactApp = window.document.getElementById("react-app");
    // console.log("Main=>", reactApp);
    reactApp?.addEventListener("click", handleMainClick);
}
function handleMainClick(event: any) {
    // console.log("targe1t=>", event.target);
    const target = event.target as HTMLElement;
    const parent = target.parentElement as HTMLElement;

    let currentElement = target.parentElement; // Start from the <a> tag's parent element

    while (currentElement) {
        if (currentElement.tagName === "MAIN") {
            if (target.tagName === "A" || parent.tagName === "A") {
                const destination = target.getAttribute("href")
                    ? target.getAttribute("href")
                    : parent.getAttribute("href");
                const minCtaClickData: MainCTAEventData = {
                    event: "cta_click",
                    cta_click_ui_location: "Main Content",
                    cta_click_destination: destination || "",
                    cta_click_text: target.innerHTML,
                    cta_click_title: target.getAttribute("title") || target.getAttribute("data-test-selector") || "",
                };
                trackMainCTAClickEvent(minCtaClickData);
            }
            break;
        }
        if (currentElement.tagName === "FOOTER") {
            if (target.tagName === "A" || parent.tagName === "A") {
                const destination = target.getAttribute("href")
                    ? target.getAttribute("href")
                    : parent.getAttribute("href");
                const headerEventData: CTAFooterEventData = {
                    event: "footer_nav_click",
                    footer_click_category: "Footer Links",
                    footer_click_text: target.innerHTML,
                    footer_click_title: target.getAttribute("data-test-selector") ?? "",
                    footer_click_destination: destination ?? "",
                };

                trackCTAFooterClickEvent(headerEventData);
            }
            break;
        }

        if (currentElement.tagName === "HEADER") {
            if (target.tagName === "A" || parent.tagName === "A") {
                const destination = target.getAttribute("href")
                    ? target.getAttribute("href")
                    : parent.getAttribute("href");
                const headerEventData: CTAEventData = {
                    event: "nav_menu_click",
                    nav_menu_category: "Header Links",
                    nav_menu_click_text: target.innerHTML,
                    nav_menu_click_title: target.getAttribute("data-test-selector") ?? "",
                    nav_menu_click_destination: destination ?? "",
                };

                trackCTAHeaderClickEvent(headerEventData);
            }
            break;
        }

        currentElement = currentElement.parentElement; // Move up to the parent element
    }
}

export function trackMainCTAClickEvent(headerEvent: MainCTAEventData) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    dataLayer.push(headerEvent);
}
export function trackSelectPromotionEvent(
    tabbedCarouselId: string,
    currentTab: string,
    currentTabLabel: string,
    title: string,
    product: ProductModel,
) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const location = getCurrentLocation();

        const selectPromotionEvent: PromotionData = {
            event: "select_promotion",
            ecommerce: {
                creative_name: title,
                creative_slot: currentTab,
                promotion_id: tabbedCarouselId,
                promotion_name: currentTabLabel,
                items: [],
            },
        };

        let catArray;
        if (product.properties?.lineCategories) {
            catArray = product.properties?.lineCategories.split("|");
            catArray = [...new Set(catArray)];
        }

        let cat1 = "";
        let cat2 = "";
        let cat3 = "";
        let cat4 = "";
        let cat5 = "";

        if (catArray && catArray.length > 0) {
            const [firstCat, secondCat, thirdCat, fourthCat, fifthCat] = catArray;
            cat1 = firstCat || "";
            cat2 = secondCat || "";
            cat3 = thirdCat || "";
            cat4 = fourthCat || "";
            cat5 = fifthCat || "";
        }

        selectPromotionEvent.ecommerce.items.push({
            item_id: product.productNumber, // "SKU_12345",
            item_name: product.productTitle, // "Stan and Friends Tee",
            index: 1,
            item_brand: product?.brand?.name || "", // "Google",
            item_category: cat1,
            item_category2: cat2,
            item_category3: cat3,
            item_category4: cat4,
            item_category5: cat5,
            location_id: location?.name || "",
            quantity: 1,
        });

        setTimeout(() => {
            dataLayer.push({ ecommerce: null });
            dataLayer.push(selectPromotionEvent);
        }, 1000);
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}

export function trackSpotlightPromotionEvent(
    tabbedCarouselId: string,
    title: string,
    currentTabLabel: string,
    currentTab: string,
    products?: ProductModel[],
) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    try {
        const location = getCurrentLocation();

        const selectPromotionEvent: PromotionData = {
            event: "view_promotion",
            ecommerce: {
                creative_name: title,
                creative_slot: currentTab,
                promotion_id: tabbedCarouselId,
                promotion_name: currentTabLabel,
                items: [],
            },
        };
        products?.forEach((product, index) => {
            let catArray;
            if (product.properties?.lineCategories) {
                catArray = product.properties?.lineCategories.split("|");
                catArray = [...new Set(catArray)];
            }

            let cat1 = "";
            let cat2 = "";
            let cat3 = "";
            let cat4 = "";
            let cat5 = "";

            if (catArray && catArray.length > 0) {
                const [firstCat, secondCat, thirdCat, fourthCat, fifthCat] = catArray;
                cat1 = firstCat || "";
                cat2 = secondCat || "";
                cat3 = thirdCat || "";
                cat4 = fourthCat || "";
                cat5 = fifthCat || "";
            }

            selectPromotionEvent.ecommerce.items.push({
                item_id: product.productNumber, // "SKU_12345",
                item_name: product.productTitle, // "Stan and Friends Tee",
                index,
                item_brand: product?.brand?.name || "", // "Google",
                item_category: cat1,
                item_category2: cat2,
                item_category3: cat3,
                item_category4: cat4,
                item_category5: cat5,
                // item_variant: "green",
                location_id: location?.name || "",
                // price: Number(productPrice) || 0,
                quantity: 1,
            });
        });
        setTimeout(() => {
            dataLayer.push({ ecommerce: null });
            dataLayer.push(selectPromotionEvent);
        }, 1000);
    } catch (e) {
        console.log("Tracking Exception =>", e);
    }
}